<template>
  <div class="flex items-center gap-x-2 group cursor-pointer">
    <div class="shrink-0 size-8 group-hover:scale-110 transition-transform relative">
      <img v-if="row.User?.avatar" :src="row.User?.avatar" class="size-full object-cover rounded-md">

      <svg v-else class="size-full object-cover rounded-md" viewBox="0 0 17 16" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M11.2091 4.66667C11.2091 6.13943 10.0151 7.33333 8.5424 7.33333C7.06964 7.33333 5.87573 6.13943 5.87573 4.66667C5.87573 3.19391 7.06964 2 8.5424 2C10.0151 2 11.2091 3.19391 11.2091 4.66667Z" stroke="currentColor" />
        <path d="M9.87573 9.33331H7.20907C5.36812 9.33331 3.87573 10.8257 3.87573 12.6666C3.87573 13.403 4.47269 14 5.20907 14H11.8757C12.6121 14 13.2091 13.403 13.2091 12.6666C13.2091 10.8257 11.7167 9.33331 9.87573 9.33331Z" stroke="currentColor" stroke-linejoin="round" />
      </svg>
    </div>
    <div class="grow group-hover:brightness-50 truncate text-xs">
      <div>{{ row.User?.name }}</div>
      <div>{{ row.User?.email }}</div>
    </div>
  </div>
</template>

<script setup>

defineProps({
  row: {
    type: Object,
    default: () => {}
  }
});
</script>
